(function () {
  const topics = ['order', 'delivery', 'returns', 'damage', 'product', 'quality', 'privacy', 'other'];
  const defaultQuestions = { order: 'order_help', delivery: 'tracking', returns: 'return_instructions', damage: 'damaged_order', product: 'product_format', quality: 'lab_reports', privacy: 'privacy_policy' };
  const questionTopics = {"delivery_options": "delivery", "tracking": "delivery", "packaging": "delivery", "destination": "delivery", "order_review": "order", "payment_methods": "order", "payment_issue": "order", "order_help": "order", "withdrawal": "returns", "return_instructions": "returns", "refund_timing": "returns", "damaged_order": "damage", "product_format": "product", "ingredient_list": "product", "certificates": "quality", "local_requirements": "other", "cool_dark": "product", "label_expiry": "product", "changes": "product", "refrigeration": "product", "batch_label": "quality", "lab_reports": "quality", "testing": "quality", "certification": "quality", "privacy_policy": "privacy", "information_use": "privacy", "newsletter_consent": "privacy", "account_help": "other", "wholesale": "other", "private_label": "other", "dropshipping": "other", "creator_partnerships": "other"};
  const valid = value => topics.includes(value) ? value : '';
  const saved = () => {
    try { const value = JSON.parse(sessionStorage.getItem('fs-service-topic')); return value && value.expires > Date.now() ? valid(value.topic) : ''; } catch { return ''; }
  };
  const save = topic => {
    try { sessionStorage.setItem('fs-service-topic', JSON.stringify({topic, expires: Date.now() + 1800000})); } catch {}
  };
  function init(root) {
    if (root.dataset.fsServiceInitialized) return;
    const form = root.querySelector('[data-fs-service-form]');
    const select = root.querySelector('[data-fs-service-topic-select]');
    if (!form || !select) return;
    root.dataset.fsServiceInitialized = 'true';
    const params = new URLSearchParams(location.search);
    const incomingQuestion = params.get('question');
    const question = Object.hasOwn(questionTopics, incomingQuestion) ? incomingQuestion : '';
    const explicitTopic = valid(params.get('topic'));
    const questionTopic = question ? questionTopics[question] : '';
    const initial = explicitTopic || questionTopic || valid(select.value) || saved();
    if (initial) select.value = initial;
    const retryKey = 'fs-service-retry';
    const retryFields = ['order_number', 'product', 'batch'];
    let contextQuestion = question;
    try {
      const retry = JSON.parse(sessionStorage.getItem(retryKey));
      const hasError = Boolean(form.querySelector('[role="alert"]'));
      const retryTopic = valid(retry?.topic);
      const retryQuestion = Object.hasOwn(questionTopics, retry?.question) ? retry.question : '';
      const retryIsFresh = retry?.expires > Date.now();
      if (hasError && retryIsFresh) {
        if (!explicitTopic && !question && retryTopic) select.value = retryTopic;
        const retryMatchesTopic = retryTopic && retryTopic === valid(select.value);
        if (!question && retryMatchesTopic && retryQuestion && questionTopics[retryQuestion] === retryTopic) contextQuestion = retryQuestion;
        if (retryMatchesTopic) retryFields.forEach(name => {
          const field = form.elements.namedItem(`contact[${name}]`);
          if (field && !field.value && typeof retry.fields?.[name] === 'string') field.value = retry.fields[name];
        });
      }
      sessionStorage.removeItem(retryKey);
    } catch {}
    form.addEventListener('submit', () => {
      if (!form.checkValidity()) return;
      const fields = {};
      retryFields.forEach(name => {
        const field = form.elements.namedItem(`contact[${name}]`);
        if (field && !field.disabled) fields[name] = field.value.slice(0, 200);
      });
      const retryQuestionId = contextQuestion && questionTopics[contextQuestion] === valid(select.value) ? contextQuestion : '';
      try { sessionStorage.setItem(retryKey, JSON.stringify({topic: valid(select.value), question: retryQuestionId, fields, expires: Date.now() + 600000})); } catch {}
    });
    const link = root.querySelector('[data-fs-service-help-link]');
    const baseHelpUrl = link?.href.split('#')[0];
    const guidance = root.querySelector('[data-fs-service-checklist]');
    const source = root.querySelector('[data-fs-service-question]');
    const update = () => {
      const topic = valid(select.value);
      root.dataset.fsServiceTopic = topic;
      if (guidance) guidance.hidden = !topic;
      root.querySelectorAll('[data-fs-service-topic]').forEach(item => { item.hidden = item.dataset.fsServiceTopic !== topic; });
      root.querySelectorAll('[data-fs-service-topic-values]').forEach(field => {
        const show = field.dataset.fsServiceTopicValues.split(',').includes(topic);
        field.hidden = !show;
        field.querySelectorAll('input,select,textarea').forEach(input => { input.disabled = !show; });
      });
      const matchingQuestion = contextQuestion && questionTopics[contextQuestion] === topic ? contextQuestion : '';
      const helpQuestion = matchingQuestion || defaultQuestions[topic];
      if (link) link.href = baseHelpUrl + (helpQuestion ? '#fs-faq-question-' + helpQuestion : '');
      if (source) { source.value = matchingQuestion; source.disabled = !matchingQuestion; }
      if (topic) save(topic);
    };
    select.addEventListener('change', () => { contextQuestion = ''; update(); });
    update();
    if (form.querySelector('.fs-service__status[role="status"]')) { try { sessionStorage.removeItem('fs-service-topic'); sessionStorage.removeItem(retryKey); } catch {} }
  }
  const focusStatus = () => document.querySelectorAll('.fs-service__status[role="status"], .fs-service__status[role="alert"]').forEach(status => { if (!status.dataset.fsStatusFocused) { status.dataset.fsStatusFocused = 'true'; status.focus({ preventScroll: true }); } });
  const initAll = () => { document.querySelectorAll('[data-fs-service-mode="customer-service"]').forEach(init); focusStatus(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, {once:true}); else initAll();
  document.addEventListener('shopify:section:load', initAll);
}());
